import { Link } from "react-router-dom";
import styles from "./AboutPageText.module.css";
import about from "../data/about";
import NavButton from "./shared/NavButton";
import ScrollTo from "react-scroll-into-view";
import { Markup } from 'interweave';

function AboutPageText() {

    const totalParagraphs = about.length;
    const totalParagraphsString = totalParagraphs.toString();

    return (
        <div className={styles.aboutContainer}>
            <div className={styles.aboutParagraphs}>
                {
                    about.map((el) => {
                        const currentParagraphId = el.id;
                        const currentAboutParagraph = "aboutParagraph" + currentParagraphId.toString();
                        const lastParagraph = about.slice(-1)[0];
                        const lastParagraphId = lastParagraph.id;
                        const currentParagraph = el.paragraph;


                        if (currentParagraphId === lastParagraphId) {

                            return (
                                < div className={styles.lastAboutParagraph} id={currentAboutParagraph} key={currentParagraphId}>
                                    <div className={styles.paragraphText}>
                                        <p className={styles.paragraphNumber}>{currentParagraphId + "/" + totalParagraphsString}</p >
                                        <p>{currentParagraph}</p>
                                    </div>
                                </div>
                            )
                        }
                        else {
                            const nextAboutParagraphSelector = "#aboutParagraph" + String(currentParagraphId + 1);

                            return (
                                <div className={styles.aboutParagraph} id={currentAboutParagraph} key={currentParagraphId}>
                                    <div className={styles.paragraphText}>
                                        <p className={styles.paragraphNumber}>{currentParagraphId + "/" + totalParagraphsString}</p >
                                        <p><Markup content={el.paragraph} /></p>
                                    </div>
                                    <ScrollTo selector={nextAboutParagraphSelector}>
                                        <div className={styles.paragraphDownButton}>
                                            <p>»</p>
                                        </div>
                                    </ScrollTo>
                                </div>
                            )
                        }
                    })
                }

            </div>
            <div className={styles.aboutNavigationButtons}>
                <Link to="/gallery">
                    <NavButton navButtonLabel="Gallery ›" />
                </Link>
                <Link to="/bibliography">
                    <NavButton navButtonLabel="Bibliography ›" />
                </Link>
                <Link to="/submissions">
                    <NavButton navButtonLabel="Submissions ›" />
                </Link>
                <Link to="/">
                    <NavButton navButtonLabel="Home ›" />
                </Link>
            </div>
        </div >

    )
}
export default AboutPageText;


